import { useQuery } from '@tanstack/react-query';
import { getPensionTransactions } from '../../../services/pension-contribution.service';

export const usePensionTransactions = (filters = null, enabled = false) => {
  return useQuery({
    queryKey: [
      'pensionTransactions',
      filters?.policyNumber || filters?.policy_number || 'all',
      filters?.schemeId || filters?.scheme_id || 'default',
      filters?.month || '',
      filters?.year || ''
    ],
    queryFn: () => getPensionTransactions(filters),
    enabled: !!enabled && !!filters,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 1,
    onError: (error) => {
      console.error('Error fetching pension transactions:', error);
    }
  });
};
